import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SketchPicker } from "react-color";

import useOutsideAlerter from "../../../../hooks/useOutsideAlerter";
import { updateStyles } from "../../../../redux/slices/userActivity";

export default function ColorPicker({
  isActive,
  handleOpen,
  handleClose,
  colorEditorPos,
  width,
  gridBackground,
  gridText,
  hover,
}) {
  const [color, setColor] = useState("rgba(22, 33, 44, 1)");

  const dispatch = useDispatch();
  const colorPickerRef = useRef(null);
  const { selectedUserActivity, userActivities, selectedComponent } =
    useSelector((state) => state.userActivity);

  const [styles, setStyles] = useState({});

  useEffect(() => {
    if (!styles) return;
    if (
      Object.keys(styles)?.length === 0 ||
      selectedComponent?.name === "image"
    )
      return;

    if (hover == true && selectedComponent.type === "button") {
      if (!Object.keys(styles).includes(selectedComponent.hoverName))
        return setColor("#dadada");
      return setColor(
        styles[selectedComponent.hoverName].backgroundColor || "#dadada"
      );
    }
    if (
      selectedComponent.name === "container" ||
      selectedComponent.name === "button" ||
      selectedComponent.type === "button"
    ) {
      return setColor(
        styles[selectedComponent.name].backgroundColor || "#dadada"
      );
    }
    if (selectedComponent.type === "crossword_grid" && gridBackground) {
      return setColor(
        styles[selectedComponent.name]?.backgroundColor || "#dadada"
      );
    }
    if (selectedComponent.type === "crossword_grid" && gridText) {
      return setColor(styles[selectedComponent.name]?.color || "#dadada");
    }
    if (styles[selectedComponent.name]?.color) {
      return setColor(styles[selectedComponent.name]?.color || "#dadada");
    }
    if (selectedComponent.type === "text") {
      return setColor("#000");
    }
  }, [styles, selectedUserActivity, selectedComponent]);

  let selectedActivityLength = 0;

  if (typeof userActivities[selectedUserActivity] === "object") {
    if (Object.keys(userActivities[selectedUserActivity]) !== undefined) {
      selectedActivityLength = Object.keys(
        userActivities[selectedUserActivity]
      ).length;
    }
  }

  useEffect(() => {
    if (
      userActivities[selectedUserActivity] &&
      Object.keys(userActivities[selectedUserActivity]).length > 1
    ) {
      setStyles(userActivities[selectedUserActivity]?.theme_id?.styles?.styles);
    }
  }, [isActive, selectedUserActivity, selectedActivityLength]);

  useOutsideAlerter(colorPickerRef, handleClose);

  const handleChange = (e) => {
    const updatedColor = `rgba(${e.rgb.r},${e.rgb.g},${e.rgb.b},${e.rgb.a})`;
    setColor(updatedColor);

    if (Object.keys(userActivities[selectedUserActivity]).length > 1) {
      let tempStyles = { ...styles };
      if (
        selectedComponent.name === "container" ||
        selectedComponent.name === "button" ||
        selectedComponent.type === "button" ||
        selectedComponent.type === "crossword_grid" ||
        selectedComponent.name === "fillintheblanksContainer"
      ) {
        if (hover === true) {
          tempStyles[selectedComponent.hoverName] = {
            backgroundColor: updatedColor,
          };
        } else {
          tempStyles[selectedComponent.name] = {
            ...styles[selectedComponent.name],
            ...(selectedComponent.name === "container" && {
              backgroundColor: updatedColor,
            }),
            ...(selectedComponent.name === "button" && {
              backgroundColor: updatedColor,
            }),
            ...(selectedComponent.type === "button" && {
              backgroundColor: updatedColor,
            }),
            ...(selectedComponent.name === "fillintheblanksContainer" && {
              backgroundColor: updatedColor,
            }),
            ...(selectedComponent.name === "grid" &&
              gridBackground && { backgroundColor: updatedColor }),
            ...(selectedComponent.name === "grid" &&
              gridText && { color: updatedColor }),
          };
        }
      } else {
        tempStyles[selectedComponent.name] = {
          ...styles[selectedComponent.name],
          color: updatedColor,
          // ...(selectedComponent.name === "container" && { backgroundColor: updatedColor }),
          // ...(selectedComponent.name === "button" && { backgroundColor: updatedColor }),
          // ...(selectedComponent.type === "button" && { backgroundColor: updatedColor }),
          // ...(selectedComponent.name === "fillintheblanksContainer" && { backgroundColor: updatedColor }),
        };
      }
      if (tempStyles[selectedComponent.name].backgroundImage) {
        delete tempStyles[selectedComponent.name].backgroundImage;
      }
      setStyles(tempStyles);
      dispatch(
        updateStyles({
          selectedActivityIdx: selectedUserActivity,
          style: tempStyles,
        })
      );
    }
  };

  return (
    <div
      className="color-select"
      onClick={handleOpen}
      style={{ backgroundColor: color }}
    >
      {isActive && (
        <div
          className="color-picker"
          ref={colorPickerRef}
          style={{
            ...(width <= 1275 && { position: "fixed" }),
            ...(width <= 1275 && { top: colorEditorPos.y + 50 }),
            ...(width <= 1275 && { left: colorEditorPos.x - 220 }),
            ...(width <= 1275 && { position: "fixed" }),
          }}
        >
          <SketchPicker
            color={color}
            onChangeComplete={(e) => handleChange(e)}
          />
        </div>
      )}
    </div>
  );
}
